export default "__VITE_ASSET__e$i5rx8i__"